export { default as getDisplayName } from './getDisplayName';
export { default as withContext } from './withContext';
export { default as provide } from './provide';
export { default as createMobXContext } from './createMobXContext';
export { default as wrap } from './wrap';
export * from './hooks';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@hilma/tools/dist/react/index.js
// module id = 74
// module chunks = 1